import React from 'react';
import { Users, Shield } from 'lucide-react';

const UserPermissions = () => {
  return (
    <div className="divide-y divide-gray-200">
      <div className="p-6">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Shield className="w-5 h-5 text-gray-500" />
          User Permissions
        </h2>
      </div>
      <div className="p-6">
        <p>User permissions configuration coming soon...</p>
      </div>
    </div>
  );
};

export default UserPermissions; 